import { autocomplete } from '@algolia/autocomplete-js';
import {useRef, useEffect} from "preact/hooks";
import {createElement, Fragment, render} from "preact";


export function AlgoliaAutocomplete(props) {
    const containerRef = useRef(null);

    useEffect(() => {
        if (!containerRef.current) {
            return undefined;
        }

        const search = autocomplete({
            container: containerRef.current,
            renderer: { createElement, Fragment, render },
            openOnFocus: true,
            ...props,
        });

        return () => {
            search.destroy();
        };
    }, [props]);

    // add ctrl+k shortcut to focus the search input
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === 'k') {
                e.preventDefault();
                containerRef.current.querySelector('input').focus();
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, []);

    return <div ref={containerRef} />;
}
